"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserSessionProvider = void 0;
var _common = require("../common");
var _jsxRuntime = require("react/jsx-runtime");
const UserSessionProvider = ({
  environment
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_common.Spa, {
  scriptOnly: true,
  environment: environment,
  name: "user-session-provider"
});
exports.UserSessionProvider = UserSessionProvider;
